import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TimeSeriesChartRoot = styled(Box)({
  display: 'flex',
  flex: 1,
  minHeight: 0,
  minWidth: 0,
});

/** Fixed-width left column: target selector or, once a target is chosen, the selection panel. */
export const SelectorArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: theme.spacing(40),
  minWidth: theme.spacing(40),
  gap: theme.spacing(1),
  padding: theme.spacing(1.3, 1, 1, 1),
}));

/** Positioning context for the selection panel, which overlays the target selector. */
export const SelectorViewport = styled(Box)({
  position: 'relative',
  flex: 1,
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
});

export const ResultArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  padding: theme.spacing(2, 3, 5, 1),
}));

export const ResultHeader = styled(Stack)(({ theme }) => ({
  alignItems: 'baseline',
  flexDirection: 'row',
  flexShrink: 0,
  gap: theme.spacing(0.5),
  paddingBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
